import Grid2 from '@mui/material/Unstable_Grid2';

import Eyebrow from '@/components/Eyebrow/Eyebrow';
import GridContainer2 from '@/components/Layout/GridContainer2/GridContainer2';
import { SpacingContainer } from '@/components/SpacingContainer/SpacingContainer';
import type { Contentful } from '@/contentful';
import useGlobalStyles from '@/styles/global.styles';

import type { CardFields } from './Cards/Cards';
import useStyles from './HighlightCards.styles';
import TabbedCards from './TabbedCards/TabbedCards';

export interface HighlightCardsContent extends Contentful {
  fields: {
    cards: CardFields[];
    headline?: string;
    subheading?: string;
    eyebrow?: string;
    style: string;
  };
}

export interface HighlightCardsProps {
  content: HighlightCardsContent;
}

const HighlightCards = ({ content: { fields } }: HighlightCardsProps) => {
  const { headline, eyebrow, subheading, style, cards } = fields;
  const isOnDark = style === 'OnDark';
  const { classes, cx } = useStyles({ isOnDark });
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });

  return (
    <SpacingContainer className={classes.container}>
      <GridContainer2 fixed gridProps={{ className: classes.grid }}>
        <Grid2 xs={12} md={6}>
          {eyebrow && <Eyebrow text={eyebrow} isOnDark={isOnDark} />}
          {headline && (
            <h2 className={cx(classes.headline, globalClasses.h2)}>
              {headline}
            </h2>
          )}
          {subheading && (
            <p className={cx(classes.subhead, globalClasses.body2)}>
              {subheading}
            </p>
          )}
        </Grid2>
        <Grid2 xs={12}>
          <TabbedCards cards={cards} isOnDark={isOnDark} />
        </Grid2>
      </GridContainer2>
    </SpacingContainer>
  );
};

export default HighlightCards;
